import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useRecoilValueLoadable } from "recoil";
import { userAtom } from "@state/State";

export const useRefreshProgramData = () => {
  const user = useRecoilValueLoadable(userAtom);
  const queryClient = useQueryClient();
  const [refreshingData, setRefreshingData] = useState<boolean>(false);

  const refreshUserProgramData = async (): Promise<void> => {
    if (!user.contents || !user.contents.userData) {
      return;
    }

    setRefreshingData(true);

    try {
      const contactID = user.contents.userData.contactID;

      // Invalidate and refetch all data queries
      // Using partial query key match for progress-check-data to refetch all variants
      const refetchPromises = [
        queryClient.refetchQueries({ queryKey: ["user-details", contactID] }),
        queryClient.refetchQueries({ queryKey: ["user-evidence", contactID] }),
        queryClient.refetchQueries({ queryKey: ["jrcalc-plus-data", contactID] }),
        queryClient.refetchQueries({ queryKey: ["parapass-quiz-data", contactID] }),
        queryClient.refetchQueries({ queryKey: ["parapass-usage-data", contactID] }),
        queryClient.refetchQueries({ queryKey: ["parapass-books-progress", contactID] }),
        queryClient.refetchQueries({ queryKey: ["progress-check-data", contactID] }),
      ];

      await Promise.all(refetchPromises);
    } catch (error) {
      console.error("Error refreshing program data:", error);
    } finally {
      setRefreshingData(false);
    }
  };

  return { isRefreshingProgramData: refreshingData, refreshUserProgramData };
};
